<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="page-box-title title1">作文润色</div>
            <div>
                <el-row :gutter="10" style="margin-top:10px;" v-if="((artiRewriteId || artiCorrectingId) && polishText.length) || (!artiRewriteId && !artiCorrectingId)">
                    <el-col :span="24">
                        <el-input maxlength="5000" v-model="polishText" :disabled="(artiRewriteId || artiCorrectingId)?true:false" type="textarea" :rows="6" placeholder="请输入作文文本，文本拍照二选一即可"></el-input>
                    </el-col>
                </el-row>
                <el-row :gutter="10" style="margin-top:10px;">
                    <el-col :span="24">
                        <el-upload class="upload-box" :disabled="(artiRewriteId || artiCorrectingId)?true:false" v-model:file-list="fileList" action="#" :max="5" list-type="picture-card" :http-request="httpRequest" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                            <div class="upload-inner">
                                <div>
                                    <el-icon size="24">
                                        <Camera />
                                    </el-icon>
                                </div>
                                <div>作文上传</div>
                            </div>
                        </el-upload>
                    </el-col>
                </el-row>
                <div class="correct-tip" v-show="!artiRewriteId && !artiCorrectingId">
                    <span class="activeColor">*提示：</span>
                    <span>一次拍一页，可多次拍摄，最多可拍摄5页</span>
                </div>
            </div>
            <div style="margin:20px 0;">
                <el-button :disabled="aiStart" style="width:100%" color="#ef8b25" class="footer-btn1" @click="polishClick">AI作文润色</el-button>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="page-box-title2 title1">
                <span>AI润色结果</span>
                <el-button style="float:right;" v-if="(Object.keys(resultInfo).length || aiMessage) && !aiStart" color="#ef8b25" class="footer-btn1" @click="copyEvent">复制全文</el-button>
            </div>
            <div class="page-inner-box" v-if="Object.keys(resultInfo).length">
                <div class="correctTitle">润色后的作文</div>
                <template v-if="resultInfo.Ⅰ && resultInfo.Ⅰ.length">
                    <div class="correctTitle2" style="text-align: center;" v-for="(item,index) in resultInfo.Ⅰ" :key="'PⅠ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
                <template v-if="resultInfo.Ⅱ && resultInfo.Ⅱ.length">
                    <div class="correctTitle5" v-for="(item,index) in resultInfo.Ⅱ" :key="'PⅡ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>

                <template v-if="resultInfo.Ⅲ && resultInfo.Ⅲ.length">
                    <div class="correctTitle">
                        修改思路和方法
                    </div>
                    <div style="text-indent: unset;" class="correctTitle5" v-for="(item,index) in resultInfo.Ⅲ" :key="'PⅢ'+index">
                        <div v-html="item"></div>
                    </div>
                </template>
            </div>
            <div v-html="aiMessage" class="page-inner-box" v-if="!Object.keys(resultInfo).length && aiMessage && aiMessage!='{}'">

            </div>
            <div class="page-inner-box empty" v-if="!Object.keys(resultInfo).length && !aiMessage">
                <img src="@/assets/img/empty.png" />
                <div>结果将在此处展示！</div>
            </div>
        </div>

        <el-image-viewer v-if="showPreview" :url-list="previewFileArr" show-progress :initial-index="previewIndex" @close="showPreview = false" />
        <AIpopup v-if="popupShow" :cancelShow="false" :popupShow="popupShow" @cancel="aiCancel"></AIpopup>
    </div>
</template>
<script lang="ts" setup>
import clipBoard from "vue-clipboard3"
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { compPolishingStreamingV2, saveSreamResult, getRewrite, getCorrecting, checkAiCall } from "@/api/composition.js"
import { uploadImg, delImgApi } from "@/api/common.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import { useRoute } from 'vue-router';
import { useStore } from "vuex"
const store = useStore();
let { toClipboard } = clipBoard()
const route = useRoute()
const polishText = ref('')
const artiRewriteId = ref('')
const artiCorrectingId = ref('')

const fileList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const previewFileArr = ref([])
let fileArr = []
let controller = null
let aiMessage = ref('')
let resultInfo = ref({})
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const aiStart = ref(false)
const popupShow = ref(false)
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function polishClick() {
    if (!polishText.value && !fileList.value.length) {
        return ElMessage.warning('请填写作文文本或拍摄作文');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}

function getAi() {
    const params = {
        grade: sessionStorage.getItem("grade"),
        term: sessionStorage.getItem("term"),
        text: polishText.value || '',
        fileIds: fileArr.map(item => {
            return item.fileId
        }).join(','),
        artiRewriteId: artiRewriteId.value || '',
        artiCorrectingId: artiCorrectingId.value || ''
    }
    aiStart.value = true
    popupShow.value = true
    fetchRequest({
        url: compPolishingStreamingV2,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
    // compPolishingStreaming(params).then(res => {
    //     fetchRequest(res.data)
    // }).catch(() => {
    //     aiStart.value = false
    //     popupShow.value = false
    // })
}


async function copyEvent() {
    try {
        let text = ''
        if (Object.keys(resultInfo.value).length) {
            if (!resultInfo.value.Ⅱ || !resultInfo.value.Ⅱ.length) {
                return ElMessage.success('当前没有符合要求的内容')
            }

            if (resultInfo.value.Ⅰ && resultInfo.value.Ⅰ.length) {
                text = resultInfo.value.Ⅰ[0]
            }
            text = (text + resultInfo.value.Ⅱ[0]).replace(/<br\/>/g, "\n");
        } else {
            text = aiMessage.value.replace(/[ⅠⅡⅢⅣⅤ]/g, '\n')
        }
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    aiMessage.value = ''
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const { signal } = controller;
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }

    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const lines = chunkText.split('\n')
            let isMessage = true;
            lines.forEach(line => {
                if (line.indexOf('Done') > -1) {
                    isMessage = false;
                    aiStart.value = false
                }
                if (line.indexOf('Error') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    return ElMessage.warning('AI调用失败，请稍后再试！');
                }
                if (line.indexOf('"500"') > -1) {
                    isMessage = false;
                    aiStart.value = false;
                    let errorMsg = JSON.parse(line).msg;
                    return ElMessage.warning(errorMsg || 'AI调用失败，请稍后再试！');
                }
                if (isMessage && line.indexOf('content') > -1) {
                    let jsonString = '';
                    if (line.startsWith('data:')) {
                        jsonString = line.substring(5).trim();
                    } else {
                        jsonString = line
                    }

                    if (jsonString) {
                        try {
                            const jsonData = JSON.parse(jsonString)
                            const content = (jsonData ?.content || '');
                            if (content) {
                                str += content
                                const matches = content.match(regex) || [];
                                let resultArr = matches.filter(match => match !== '');
                                resultArr.forEach(info => {
                                    if (romanNumerals.includes(info)) {
                                        if (info in resultNum) {
                                            resultNum[info] = resultNum[info] + 1;
                                            resultInfo.value[info].push('');
                                        } else {
                                            resultNum[info] = 1;
                                            resultInfo.value[info] = [''];
                                        }
                                        currentKey = info;
                                    } else if (currentKey in resultInfo.value) {
                                        if (resultNum[currentKey] == 1) {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/^\s+/, "").replace(/\n+/g, '<br/>');
                                        } else {
                                            resultInfo.value[currentKey][resultNum[
                                                currentKey] - 1] += info.replace(/\n+/g, '<br/>');
                                        }

                                    }
                                })
                                console.log(resultInfo.value)
                                aiMessage.value = str
                            }
                        } catch (error) {
                            console.log(error)
                            aiStart.value = false
                            return ElMessage.warning('AI调用失败，请稍后再试！');
                        }
                    }
                }
            })
        } else {
            aiStart.value = false;
        }
    }
}

function httpRequest(params) {
    const fileInfo = new FormData()
    fileInfo.append('file', params.file)
    const loading = ElLoading.service({
        lock: true,
        background: 'rgba(0, 0, 0, 0.5)',
    })
    uploadImg(fileInfo).then(res => {
        fileArr.push(res.data)
        previewFileArr.value.push(res.data.fileUrl)
        fileList.value[fileList.value.length - 1]['fileId'] = res.data.fileId;
    }).finally(() => {
        loading.close()
    })
}

function handlePictureCardPreview(file) {
    previewIndex.value = fileArr.findIndex(item => {
        return item.fileId == file.fileId
    })
    showPreview.value = true;
}

function handleRemove(file) {
    if (file.fileId) {
        const index = fileArr.findIndex(item => {
            return item.fileId == file.fileId
        })
        // delImgApi(file.fileId).then(res => {
        ElMessage.success('删除成功')
        fileArr.splice(index, 1)
        previewFileArr.value.splice(index, 1)
        // })
    }
}

function getDetail() {
    const api = artiRewriteId.value ? getRewrite : getCorrecting;
    api(artiRewriteId.value || artiCorrectingId.value).then(res => {
        const ids = res.data.artiCorrectingFileIds || res.data.artiRewriteFileIds || '';
        const fileids = ids ? ids.split(',') : [];
        fileList.value = (res.data.artiCorrectingFileUrlList || res.data.artiRewriteFileUrlList || [])
            .map((item, index) => {
                return {
                    fileUrl: item,
                    url: item,
                    fileId: fileids[index]
                }
            });
        fileArr = fileList.value;
        previewFileArr.value = (res.data.artiCorrectingFileUrlList || res.data.artiRewriteFileUrlList || [])
        console.log(previewFileArr.value)
        polishText.value = res.data.artiCorrectingTxt || res.data.artiRewriteTxt || '';
    })
}

onBeforeUnmount(() => {
    controller && controller.abort()
})

onMounted(() => {
    artiRewriteId.value = route.query.artiRewriteId || '';
    artiCorrectingId.value = route.query.artiCorrectingId || '';
    if (artiRewriteId.value || artiCorrectingId.value) {
        getDetail()
    }
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.correct-title {
    font-size: 12px;
    color: $base-text-color;
    line-height: 1.8;
    margin: 20px 0;
}

.correct-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}
</style>
